import { supabase } from '@/integrations/supabase/client';

interface AITextEditRequest {
  selectedText: string;
  instruction: string;
  model?: string;
}

/**
 * Call the ai-text-edit edge function as the signed-in user. The function
 * rejects the anon key, so this sends the user's access token instead.
 */
export async function requestAITextEdit(body: AITextEditRequest): Promise<string> {
  const { data } = await supabase.auth.getSession();
  const accessToken = data?.session?.access_token;
  if (!accessToken) {
    throw new Error('You must be signed in to use AI editing');
  }

  const res = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/ai-text-edit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const errData = await res.json().catch(() => ({ error: 'AI request failed' }));
    if (res.status === 429) {
      throw new Error('Rate limit exceeded. Please try again later.');
    }
    if (res.status === 402) {
      throw new Error('AI credits exhausted. Please add credits to continue.');
    }
    throw new Error(errData.error || 'AI request failed');
  }

  const { result } = await res.json();
  return result;
}
